module.exports = __webpack_public_path__ + "media/images/gdoe_usc-4a6290c60e49e9beb174c34e511a5aa5.svg";